import { UpdateReportRequest } from '@api';
import { MapUpdateReportRequestProps } from './mapUpdateReportRequest.types';
import { mapBaseReportBody } from '../mapBaseReportBody';

export const mapUpdateReportRequest = ({
  visibleColumns,
  compoundFilterState,
  filters,
  name,
  reportId,
}: MapUpdateReportRequestProps) => {
  const request: UpdateReportRequest = {
    body: mapBaseReportBody({ visibleColumns, compoundFilterState, filters, name }),
    routeParams: {
      id: reportId,
    },
  };

  return request;
};
